// extracted by mini-css-extract-plugin
export default {"addToCartControl":"r2-z","giftCard":"s2-z","btnContainer":"t2-z","cartButton":"u2-z","disabled":"v2-z","stockMessage":"w2-z"};